// extracted by mini-css-extract-plugin
export default {"auth__section":"auth_auth__section__9zbkR","form__wrapper":"auth_form__wrapper__QxnCi","logo__wrapper":"auth_logo__wrapper__7pQf-","form__header":"auth_form__header__vzaXu"};